import { act, JSX } from "../../jsx-act"
import './space-between.scss'

interface SpaceBetweenProps extends Record<string, unknown> {
  children?: JSX.Child,
  size?: 'xxs' | 'xs' | 's' | 'm'
  direction?: 'horizontal' | 'vertical'
}

export default ({ children, size = 'm', direction = 'horizontal', ...props }: SpaceBetweenProps) => {
  return (
    <div {...props} class={`awsccc-u-sb awsccc-u-sb-${size} awsccc-u-sb-${direction === 'horizontal' ? 'h' : 'v'} ${props.class || ''}`}>
      {children}
    </div>
  )
}
